import { useRouter } from "../../useRouter";

// 통화/결제사는 화면 언어 기준 (ko → 원화/이니시스, 그 외 → 달러/페이팔)
// 요금제 선택 화면(SiteType)도 lang 기준이라 두 화면의 통화가 일치한다.
export function useGetCurrencyCode() {
  const { lang } = useRouter();
  const isKo = lang === "ko";
  return {
    currency: isKo ? "WON" : "USD",
    payCompany: (isKo ? "INICIS" : "PAYPAL") as "INICIS" | "PAYPAL",
  };
}
